import type { ReactNode } from 'react';
import { cn } from '../lib/utils';

type Props = {
  children: ReactNode;
  className?: string;
};

export const PageLayout = ({ children, className }: Props) => {
  return (
    <section
      data-slot="page-layout"
      className={cn(
        'flex h-full w-full flex-col overflow-hidden rounded-2xl border border-primary-10 border-solid bg-white',
        className,
      )}
    >
      {children}
    </section>
  );
};
